<script lang="ts">
	import { _ } from "svelte-i18n";
	import { Button, Spinner } from "@sveltestrap/sveltestrap";
	import { generateTopic } from "../../actions/generateTopic";
	import { pushToast } from "../../store/toasts";

	let { onTopic }: { onTopic?: (topic: string) => void } = $props();

	let generatingTopic = $state(false);

	async function onClick() {
		generatingTopic = true;
		try {
			const topic = await generateTopic();
			onTopic?.(topic);
		} catch {
			pushToast({
				variant: "danger",
				message: $_("landingpage.newPresentation.generateTopicFailed"),
			});
		} finally {
			generatingTopic = false;
		}
	}
</script>

<Button type="button" color="secondary" outline disabled={generatingTopic} on:click={onClick}>
	{#if generatingTopic}
		<Spinner size="sm" class="me-1" />
	{/if}
	{$_("landingpage.newPresentation.generateTopic")}
</Button>
